// Auto-generated from backend schema
// DO NOT EDIT MANUALLY - regenerate with: python scripts/generate-field-config.py
// Run: python scripts/generate-field-config.py

import { FieldType } from '../fieldConfig.types';
import type { FieldSchema } from '../fieldConfig.types';

/**
 * Generated field configurations from backend Pydantic schema.
 * These are merged with manual overrides in fieldConfig.ts
 */
export const GENERATED_FIELD_CONFIG: Record<string, FieldSchema> = {
  'hooks.classifier.custom_quick_keywords': {
    type: FieldType.TEXT,
    label: '自定义快速回复关键词',
    section: 'classification_rules',
    help: '额外的关键词，包含这些关键词的消息将被分类为快速回复。',
    default: null,
    placeholder: '输入关键词后按回车',
  },
  'hooks.classifier.custom_quick_patterns': {
    type: FieldType.TEXT,
    label: '自定义快速回复模式 (正则)',
    section: 'classification_rules',
    help: '额外的正则表达式，匹配的消息将被分类为快速回复。留空使用系统默认规则。',
    default: null,
    placeholder: '例: ^(查余额|签到)[呀啊]?$',
  },
  'hooks.classifier.llm_fallback_enabled': {
    type: FieldType.CHECKBOX,
    label: '启用LLM分类回退',
    section: 'classification_rules',
    help: '当规则匹配失败时，是否使用LLM进行技能分类。关闭可减少API开销，但可能遗漏规则未覆盖的技能。',
    default: true,
  },
  'hooks.classifier.llm_timeout': {
    type: FieldType.NUMBER,
    label: 'LLM 超时（秒）',
    section: 'response_classifier',
    help: 'LLM 分类超时时间（秒）。超时后默认使用深度响应。',
    default: 3.0,
    step: 0.5,
    min: 0.5,
    max: 10.0,
  },
  'hooks.classifier.quick_response_instructions': {
    type: FieldType.TEXTAREA,
    label: '快速响应提示词',
    section: 'quick_response',
    help: '当分类为快速响应时，用此提示词替代系统提示词。留空则不替换。',
    default: '',
    rows: 6,
    placeholder: '你是一个友好的助手。请简洁、自然地回复用户的问候或简单问题。保持轻松愉快的对话氛围。',
    showIfPath: '!hooks.classifier.use_system_instructions',
  },
  'hooks.classifier.quick_response_max_length': {
    type: FieldType.NUMBER,
    label: '快速响应最大长度',
    section: 'response_classifier',
    help: '消息长度（字符）阈值，超过此长度倾向于深度响应',
    default: 50,
    step: 10,
    min: 10,
    max: 500,
  },
  'hooks.classifier.rule_confidence_threshold': {
    type: FieldType.NUMBER,
    label: '规则置信度阈值',
    section: 'response_classifier',
    help: '规则分类置信度阈值，低于此值时使用 LLM 分类。范围: 0.0-1.0',
    default: 0.8,
    step: 0.05,
    min: 0.0,
    max: 1.0,
  },
  'hooks.classifier.use_system_instructions': {
    type: FieldType.CHECKBOX,
    label: '沿用系统提示词',
    section: 'quick_response',
    help: '勾选后，快速响应将使用主系统提示词，不再替换为独立的快速响应提示词',
    default: false,
  },
  'hooks.device.enabled': {
    type: FieldType.CHECKBOX,
    label: '设备感知',
    section: 'context_awareness',
    help: '启用设备感知',
    default: false,
  },
  'hooks.location.enabled': {
    type: FieldType.CHECKBOX,
    label: '位置感知',
    section: 'context_awareness',
    help: '启用位置感知',
    default: false,
  },
  'hooks.quick_chat.enabled': {
    type: FieldType.CHECKBOX,
    label: '快速响应',
    section: 'models_quick_chat',
    help: '启用快速响应',
    default: true,
  },
  'hooks.reasoning.enabled': {
    type: FieldType.CHECKBOX,
    label: '推理能力',
    section: 'models_reasoning',
    help: '启用推理能力',
    default: false,
  },
  'hooks.reasoning.mode': {
    type: FieldType.SELECT,
    label: '推理模式',
    section: 'models_reasoning',
    help: '推理模式: \'native\' (使用主模型) or \'combined\' (独立推理模型)',
    default: 'native',
    options: [
      { value: 'native', label: '原生' },
      { value: 'combined', label: '组合' },
    ],
    buttonGroup: true,
  },
  'hooks.stt.enabled': {
    type: FieldType.CHECKBOX,
    label: '语音输入',
    section: 'models_stt',
    help: '启用语音输入',
    default: false,
  },
  'hooks.vision.enabled': {
    type: FieldType.CHECKBOX,
    label: '视觉模型',
    section: 'models_vision',
    help: '启用视觉模型',
    default: false,
  },
  'models.image.default_aspect_ratio': {
    type: FieldType.SELECT,
    label: '默认宽高比',
    section: 'models_image',
    help: 'Default aspect ratio when not specified by user',
    default: '1:1',
    options: [
      { value: '1:1', label: '1:1 · 方形' },
      { value: '3:4', label: '3:4 · 竖版' },
      { value: '4:3', label: '4:3 · 横版' },
      { value: '16:9', label: '16:9 · 宽屏' },
      { value: '9:16', label: '9:16 · 竖屏' },
    ],
  },
  'models.image.image_size': {
    type: FieldType.SELECT,
    label: '默认图片尺寸',
    section: 'models_image',
    help: 'Default output image size',
    default: '1K',
    options: [
      { value: '1K', label: '1K (1024px)' },
      { value: '2K', label: '2K (2048px)' },
      { value: '4K', label: '4K (4096px)' },
    ],
  },
  'models.image.model_id': {
    type: FieldType.MODEL_SELECTOR,
    label: '默认画图模型',
    section: 'models_image',
    help: 'Default image model (used when tool receives model=\'auto\'). None = use system default.',
    default: null,
    optionsSource: 'imageModels',
    allowEmpty: true,
    emptyLabel: '使用系统默认',
  },
  'models.image.quality_model_id': {
    type: FieldType.MODEL_SELECTOR,
    label: '高质量画图模型',
    section: 'models_image',
    help: 'Quality image model (used when tool receives model=\'quality\'). None = use system default.',
    default: null,
    optionsSource: 'imageModels',
    allowEmpty: true,
    emptyLabel: '使用系统默认',
  },
  'models.reasoning.model_id': {
    type: FieldType.MODEL_SELECTOR,
    label: '推理模型',
    section: 'models_reasoning',
    help: 'Reasoning model for extended thinking. None to disable reasoning.',
    default: null,
    optionsSource: 'reasoningModels',
    allowEmpty: true,
    emptyLabel: '使用系统默认',
  },
  'models.reranking.model_id': {
    type: FieldType.MODEL_SELECTOR,
    label: '重排序模型',
    section: 'models_reranking',
    help: 'Reranker model',
    default: 'BAAI/bge-reranker-v2-m3',
    optionsSource: 'rerankingModels',
  },
  'models.stt.language': {
    type: FieldType.SELECT,
    label: '识别语言',
    section: 'models_stt',
    help: 'Language hint (e.g., \'zh\', \'en\')',
    default: null,
    options: [
      { value: '', label: '自动' },
      { value: 'zh', label: '中文' },
      { value: 'en', label: '英语' },
      { value: 'ja', label: '日语' },
      { value: 'ko', label: '韩语' },
    ],
    buttonGroup: true,
  },
  'models.stt.model_id': {
    type: FieldType.MODEL_SELECTOR,
    label: '语音识别模型',
    section: 'models_stt',
    help: 'STT model',
    default: 'stable/glm-asr-2512',
    optionsSource: 'sttModels',
  },
  'models.task.max_tokens': {
    type: FieldType.NUMBER,
    label: '最大 Token 数',
    section: 'models_task',
    help: '任务输出的最大 Token 数',
    default: 2000,
  },
  'models.task.model_id': {
    type: FieldType.MODEL_SELECTOR,
    label: '任务模型',
    section: 'models_task',
    help: '用于各类子任务的轻量级模型（压缩、分类、摘要等）',
    default: null,
    optionsSource: 'chatModels',
  },
  'models.task.temperature': {
    type: FieldType.NUMBER,
    label: '温度',
    section: 'models_task',
    help: '较低的温度使输出更确定性',
    default: 0.3,
    step: 0.1,
    min: 0,
    max: 2,
  },
  'models.vision.model_id': {
    type: FieldType.MODEL_SELECTOR,
    label: '主视觉模型',
    section: 'models_vision',
    help: 'Vision model for DEEP responses',
    default: null,
    optionsSource: 'visionModels',
  },
  'models.vision.quick_model_id': {
    type: FieldType.MODEL_SELECTOR,
    label: '快速视觉模型',
    section: 'models_vision',
    help: 'Vision model for QUICK responses',
    default: null,
    optionsSource: 'visionModels',
    allowEmpty: true,
    emptyLabel: '使用主视觉模型',
  },
  'tools.compression.enabled': {
    type: FieldType.CHECKBOX,
    label: '压缩工具结果',
    section: 'tools_compression',
    help: '用 LLM 摘要压缩工具返回内容，保留关键信息（数字/日期/实体），减少上下文占用',
    default: false,
  },
  'tools.compression.model_id': {
    type: FieldType.MODEL_SELECTOR,
    label: '压缩模型',
    section: 'tools_compression',
    help: '执行摘要压缩的模型，留空则使用任务模型',
    default: null,
    optionsSource: 'chatModels',
    allowEmpty: true,
    emptyLabel: '使用任务模型',
    showIfPath: 'tools.compression.enabled',
  },
  'tools.compression.results_limit': {
    type: FieldType.NUMBER,
    label: '触发条数',
    section: 'tools_compression',
    help: '累计多少条未压缩的工具结果后触发压缩（默认 3）',
    default: 3,
    min: 1,
    max: 50,
    showIfPath: 'tools.compression.enabled',
  },
  'tools.compression.token_limit': {
    type: FieldType.NUMBER,
    label: 'Token 阈值',
    section: 'tools_compression',
    help: '上下文总 Token 达到此值时触发压缩，留空则仅按条数触发',
    default: null,
    showIfPath: 'tools.compression.enabled',
  },
  'tools.parallel_tool_calls': {
    type: FieldType.CHECKBOX,
    label: '并行工具调用',
    section: 'tools_execution',
    help: '允许模型同时调用多个工具（Claude 支持），关闭则强制逐个调用',
    default: false,
  },
};
